import { FormType } from '@cod-monorepo/interfaces';
import { StepConfig } from '../../../../shared/types/step-config.type';

export const ReferenceNumberDomesticStepConfig: StepConfig = {
    type: FormType.REFERENCE_NUMBER_DOMESTIC
};
